import { Injectable } from '@angular/core';
import { DWS } from '@interfaces/dws';
import { resource } from '@util/resource';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckInQrCodeReaderService {

  constructor() { }

  checkIn(qrCode: DWS.CheckInQrCodeReader): Observable<DWS.CheckInQrCodeReader.Result> {
    return resource('crm://public/reservations/check-in-qr-code')
      .post<DWS.CheckInQrCodeReader.Result>(qrCode);
  }

}
